// Legacy-token aliases for permission strings that replaced a BORROWED one.
//
// Every gated element has its own permission string (PO, 2026-10-07). Legacy
// tenants take their permissions from the Auth0 token, which is configured
// outside the repo; until each new string is added there, a token holding the
// old string also counts as holding the new one, so nobody loses an element.
// Remove an entry once Auth0 carries the new string on every environment.
//
// Same table on the backend: `new-backend/admin/src/lib/legacyTokenAliases.ts`
// (its test pins the two copies to each other).
export const LEGACY_TOKEN_ALIASES: Readonly<Record<string, readonly string[]>> = {
    'export:issue-reports': ['read:dashboard'], // #3064
    'manage:products': ['create:assets'],
    'delete:products': ['delete:assets'],
    'read:assets': ['create:assets'],
    'read:invoices': ['read:bookings'],
    'manage:invoices': ['create:bookings'],
    'view:voucher-history': ['read:vouchers'], // #3261
    'manage:vouchers': ['read:vouchers'],
    'manage:banners': ['read:vouchers'],
    'edit:deposit-settings': ['create:assets'],
};

/** The permissions plus every new string an old one stands in for. */
export const withLegacyTokenAliases = (permissions: readonly string[]): string[] => {
    const granted = new Set(permissions);
    Object.entries(LEGACY_TOKEN_ALIASES).forEach(([replacement, legacy]) => {
        if (legacy.some((p) => granted.has(p))) granted.add(replacement);
    });
    return Array.from(granted);
};
